<template>
  <div class="main-navigation">
    <div class="main-navigation__inner">
      <tabbed-navigation v-show="$route.name !== 'login'" class="navigation-list" />

      <news-notify v-show="$route.name !== 'login'" class="news-notify" />

      <language-changer
        v-if="$route.name !== 'devicelist'"
        class="language-witcher"
      ></language-changer>
    </div>
  </div>
</template>

<script>
import TabbedNavigation from './tabbedNavigation';
import LanguageChanger from './changeLanguage.vue';
import NewsNotify from './newsNotify';

export default {
  name: 'MainNavigation',
  components: {
    TabbedNavigation,
    LanguageChanger,
    NewsNotify
  }
};
</script>

<style lang="scss" scoped>
.main-navigation {
  position: fixed;
  top: 0;
  margin: 0 auto;
  width: 100%;
  height: 48px;
  background: white;
  box-shadow: 0 2px 8px 0 rgba(60, 70, 75, 0.2);
  z-index: 10;
  display: flex;

  &__inner {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }

  .tabbedNavigation {
    display: none;
    margin: auto;
  }

  .language-switcher {
    // margin-top: -5px;
    // width: 60px;
    width: 45px;
    max-width: 100px;
    position: initial;
  }

  .news-notify {
    margin: 0 16px;
    display: flex;
    justify-content: flex-end;
  }

  @include breakpoint(xs) {
    .news-notify {
      margin: 0 8px;
      width: 100%;
    }
  }

  @include breakpoint(sm) {
    .tabbedNavigation {
      display: block;
    }
  }
}
</style>
